
import { defineComponent } from 'vue';
import ApplyAvatarPosterTemplate from '@/components/templates/program/ApplyAvatarPosterTemplate.vue';
import { useI18n } from '@/plugins/i18n';
import JaMessages from '@/assets/i18n/ja/program/apply_avatar_poster.json';
import EnMessages from '@/assets/i18n/en/program/apply_avatar_poster.json';
import { pageview } from 'vue-gtag';

export default defineComponent({
  name: 'ApplyAvatarPoster',
  components: { ApplyAvatarPosterTemplate },
  methods: {
    track() {
      pageview({ page_path: '/program/apply_avatar_poster' });
    },
  },
  setup() {
    const i18n = useI18n();
    i18n.$setMessages(JaMessages, EnMessages);

    return {
      i18n,
    };
  },
});
